import { PERSONALINFO } from "../../util/constants/personalInfo";


export default function LinksAndDetails() {

    return(
        <>
            <div
                className="
                    flex
                    flex-col
                "
            >
                <span
                    className="
                        text-xs
                        text-body-text-grey
                        
                        font-semibold
                        tracking-wide
                        mb-4
                    "
                >
                    DETAILS
                </span>

                <a
                    href={`mailto:` + PERSONALINFO.email}
                    className="
                        hover:text-footerCTA-text-primary
                        transition-colors 
                        duration-300

                        text-base
                        tracking-wide
                        my-0.5
                        w-min
                        text-nowrap
                    "
                >
                    {
                        PERSONALINFO.email
                    }
                </a>


                <a
                    href={`tel:` + PERSONALINFO.phone}
                    className="
                        hover:text-footerCTA-text-primary
                        transition-colors 
                        duration-300

                        text-base
                        tracking-wide
                        my-0.5
                        w-min
                        text-nowrap
                    "
                >
                    {
                        PERSONALINFO.phone
                    }
                </a>


                <span
                    className="
                        text-xs
                        text-body-text-grey
                        
                        font-semibold
                        tracking-wide
                        mt-5
                        mb-4
                    "
                >
                    LINKS
                </span>

                <a
                    href={PERSONALINFO.instagramLink}
                    target="_blank"
                    rel="noreferrer"
                    className="
                        hover:text-footerCTA-text-primary
                        transition-colors 
                        duration-300

                        text-base
                        tracking-wide
                        my-0.5
                        w-min
                        text-nowrap
                    "
                >
                    Instagram
                </a>


                <a
                    href={PERSONALINFO.linkedInLink}
                    target="_blank"
                    rel="noreferrer"
                    className="
                        hover:text-footerCTA-text-primary
                        transition-colors 
                        duration-300

                        text-base
                        tracking-wide
                        my-0.5
                        w-min
                        text-nowrap
                    "
                >
                    LinkedIn
                </a>


                <a
                    href={PERSONALINFO.githubLink}
                    target="_blank"
                    rel="noreferrer"
                    className="
                        hover:text-footerCTA-text-primary
                        transition-colors 
                        duration-300

                        text-base
                        tracking-wide
                        my-0.5
                        w-min
                        text-nowrap
                    "
                >
                    GitHub
                </a>


            </div>
        </>
    );
}